import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { CONTACT } from "./data";

function Block({ title, children }) {
  return (
    <div className="border-t border-white/10 py-8 first:border-t-0 first:pt-0">
      <h3 className="mb-4 font-mono-spc text-[11px] uppercase tracking-[0.3em] text-[#4fd1c5]">{title}</h3>
      <div className="space-y-2 font-light leading-relaxed text-[#c0c5ce]/80">{children}</div>
    </div>
  );
}

export default function Impressum({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="impressum-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[60] flex justify-end bg-[#0d0d0f]/80 backdrop-blur-sm"
        >
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative h-full w-full max-w-2xl overflow-y-auto border-l border-white/10 bg-[#111214] px-8 py-16 lg:px-14"
          >
            <button
              data-testid="impressum-close"
              onClick={onClose}
              className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center rounded-sm border border-white/10 text-white transition-colors duration-300 hover:border-[#4fd1c5] hover:text-[#4fd1c5]"
              aria-label="Schliessen"
            >
              <X className="h-5 w-5" strokeWidth={1.5} />
            </button>

            <span className="font-mono-spc text-[11px] uppercase tracking-[0.35em] text-[#4fd1c5]">Rechtliches</span>
            <h2 className="mb-10 mt-4 font-head text-4xl font-light uppercase tracking-tighter text-metal sm:text-5xl">
              Impressum
            </h2>

            <Block title="EMMAX Dienstleistungs GmbH">
              <p>EMMAX Dienstleistungs GmbH</p>
              <p>{CONTACT.address}</p>
              <p>{CONTACT.city}</p>
              <p>Schweiz</p>
            </Block>

            <Block title="Geschäftsbezeichnung">
              <p>Swiss Precision Cleaning ist eine Marke der EMMAX Dienstleistungs GmbH.</p>
              <p>
                Sämtliche unter der Marke Swiss Precision Cleaning angebotenen Dienstleistungen werden von der
                EMMAX Dienstleistungs GmbH erbracht. Vertragspartner für alle angebotenen Leistungen ist
                ausschliesslich die EMMAX Dienstleistungs GmbH, sofern im Einzelfall nichts Abweichendes
                schriftlich vereinbart wurde.
              </p>
            </Block>

            <Block title="Vertretungsberechtigte Person">
              <p>Matthias Lang</p>
              <p className="text-[#8a919e]">General Manager</p>
            </Block>

            <Block title="Kontakt">
              <p>
                Telefon:{" "}
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="transition-colors hover:text-[#4fd1c5]">
                  {CONTACT.phone}
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-[#4fd1c5]">
                  {CONTACT.email}
                </a>
              </p>
            </Block>

            <Block title="Handelsregister">
              <p>Handelsregister des Kantons Basel-Landschaft</p>
              <p>Firmenname: EMMAX Dienstleistungs GmbH</p>
              <p>UID: CHE-XXX.XXX.XXX</p>
              <p>Mehrwertsteuer-Nr.: CHE-XXX.XXX.XXX MWST (falls mehrwertsteuerpflichtig)</p>
            </Block>

            <Block title="Haftungsausschluss">
              <p>
                Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt erstellt und regelmässig überprüft.
                Dennoch übernimmt die EMMAX Dienstleistungs GmbH keine Gewähr für die Richtigkeit, Vollständigkeit
                und Aktualität der bereitgestellten Informationen.
              </p>
              <p>
                Eine Haftung für Schäden materieller oder immaterieller Art, die durch den Zugriff auf, die Nutzung
                oder Nichtnutzung der veröffentlichten Informationen oder durch technische Störungen entstehen, ist
                – soweit gesetzlich zulässig – ausgeschlossen.
              </p>
            </Block>

            <Block title="Haftung für externe Links">
              <p>
                Diese Website enthält gegebenenfalls Verweise (Links) auf externe Websites Dritter. Auf deren
                Inhalte hat die EMMAX Dienstleistungs GmbH keinen Einfluss und übernimmt hierfür keine Verantwortung.
                Für den Inhalt der verlinkten Seiten ist ausschliesslich der jeweilige Betreiber verantwortlich. Zum
                Zeitpunkt der Verlinkung waren keine rechtswidrigen Inhalte erkennbar.
              </p>
            </Block>

            <Block title="Urheberrecht">
              <p>
                Alle auf dieser Website veröffentlichten Inhalte, insbesondere Texte, Bilder, Grafiken, Logos,
                Videos, Dokumente sowie das Design der Website, sind urheberrechtlich geschützt.
              </p>
              <p>
                Jede Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Nutzung ausserhalb der gesetzlichen
                Bestimmungen bedarf der vorherigen schriftlichen Zustimmung der EMMAX Dienstleistungs GmbH, sofern
                nicht ausdrücklich etwas anderes angegeben ist.
              </p>
            </Block>

            <Block title="Anwendbares Recht">
              <p>Sämtliche Rechtsbeziehungen im Zusammenhang mit dieser Website unterliegen dem schweizerischen Recht.</p>
              <p>Soweit gesetzlich zulässig, ist Gerichtsstand der Sitz der EMMAX Dienstleistungs GmbH.</p>
            </Block>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
